// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateCriteria = criteria => ({
    criteria,
    type: actions.UPDATE_PIP_HISTORY_REPORT_CRITERIA
});

export const resetCriteria = () => ({
    type: actions.RESET_PIP_HISTORY_REPORT_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/pip-history/action-creators/criteria.js